import React from 'react';
import { Grid, TextField, Typography, Box, MenuItem, Accordion, AccordionSummary, AccordionDetails, Checkbox, FormControlLabel } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NotificationsIcono from '@material-ui/icons/NotificationsActiveOutlined';
import { TIPOS_FORMAS_ASESORIAS} from '../../helper';
import { FORM_DICTIONARY } from './schemas/formFields';


export function FormularioConsentimientoGeneral({ state, onChange, onError, pintarSelect, programaOpciones, tipoAsesoriasOpciones, formasAsesoriasOpciones = [], parentescosOpciones = [] }) {
    const formasOpciones = Array.isArray(formasAsesoriasOpciones) && formasAsesoriasOpciones.length > 0
        ? formasAsesoriasOpciones
        : TIPOS_FORMAS_ASESORIAS;
    const parentescos = Array.isArray(parentescosOpciones) ? parentescosOpciones : [];
    const campos_g = FORM_DICTIONARY.consentimiento.general;
    return (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            {/* Tipo de Asesoría Individual */}
            <Grid item xs={12} md={6}>
                {pintarSelect(campos_g.tipo_asesoria_individual.label, campos_g.tipo_asesoria_individual.name, tipoAsesoriasOpciones)}
            </Grid>

            {/* Tipo de Asesoría */}
            <Grid item xs={12} md={6}>
                {pintarSelect(campos_g.tipo_asesoria_consentimiento.label, campos_g.tipo_asesoria_consentimiento.name, formasOpciones)}
            </Grid>

            {/* Nombre Completo - OCULTO (pero se guarda) */}
            <Grid item xs={12} md={6} style={{ display: 'none'}} >
                <TextField
                    fullWidth
                    required
                    label={campos_g.nombre_completo_consent.label}
                    name={campos_g.nombre_completo_consent.name}
                    value={state.nombre_completo_consent.valor}
                    onChange={onChange}
                    error={onError(state.nombre_completo_consent.error)}
                    helperText={state.nombre_completo_consent.error}
                />
            </Grid>

            {/* Identificación - OCULTO (pero se guarda) */}
            <Grid item xs={12} md={6} style={{ display: 'none'}} >
                <TextField
                    fullWidth
                    required
                    label={campos_g.identificacion_consent.label}
                    name={campos_g.identificacion_consent.name}
                    value={state.identificacion_consent.valor}
                    onChange={onChange}
                    error={onError(state.identificacion_consent.error)}
                    helperText={state.identificacion_consent.error}
                />
            </Grid>

            {/* Celular - OCULTO (pero se guarda) */}
            <Grid item xs={12} md={6} style={{ display: 'none'}} >
                <TextField
                    fullWidth
                    required
                    type="number"
                    label={campos_g.celular_consent.label}
                    name={campos_g.celular_consent.name}
                    value={state.celular_consent.valor}
                    onChange={onChange}
                    error={onError(state.celular_consent.error)}
                    helperText={state.celular_consent.error}
                />
            </Grid>

            {/* Contacto de Emergencia 1 */}
            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    required
                    label={campos_g.contacto_emergencia_1.label}
                    name={campos_g.contacto_emergencia_1.name}
                    value={state.contacto_emergencia_1.valor}
                    onChange={onChange}
                    error={onError(state.contacto_emergencia_1.error)}
                    helperText={state.contacto_emergencia_1.error}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    required
                    type="number"
                    label={campos_g.celular_contacto_1.label}
                    name={campos_g.celular_contacto_1.name}
                    value={state.celular_contacto_1.valor}
                    onChange={onChange}
                    error={onError(state.celular_contacto_1.error)}
                    helperText={state.celular_contacto_1.error}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    select
                    fullWidth
                    required
                    label={campos_g.parentesco_contacto_1.label}
                    name={campos_g.parentesco_contacto_1.name}
                    value={state.parentesco_contacto_1.valor}
                    onChange={onChange}
                    error={onError(state.parentesco_contacto_1.error)}
                    helperText={state.parentesco_contacto_1.error}
                >
                    {parentescos.map((op) => (
                        <MenuItem key={op.value} value={op.value}>{op.label}</MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    required
                    label={campos_g.contacto_emergencia_2.label}
                    name={campos_g.contacto_emergencia_2.name}
                    value={state.contacto_emergencia_2.valor}
                    onChange={onChange}
                    error={onError(state.contacto_emergencia_2.error)}
                    helperText={state.contacto_emergencia_2.error}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    required
                    type="number"
                    label={campos_g.celular_contacto_2.label}
                    name={campos_g.celular_contacto_2.name}
                    value={state.celular_contacto_2.valor}
                    onChange={onChange}
                    error={onError(state.celular_contacto_2.error)}
                    helperText={state.celular_contacto_2.error}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    select
                    fullWidth
                    required
                    label={campos_g.parentesco_contacto_2.label}
                    name={campos_g.parentesco_contacto_2.name}
                    value={state.parentesco_contacto_2.valor}
                    onChange={onChange}
                    error={onError(state.parentesco_contacto_2.error)}
                    helperText={state.parentesco_contacto_2.error}
                >
                    {parentescos.map((op) => (
                        <MenuItem key={op.value} value={op.value}>{op.label}</MenuItem>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    );
}

export function FormularioConsentimientoCrisis({ state, onChange, onError, parentescosOpciones = [] }) {
    const parentescos = Array.isArray(parentescosOpciones) ? parentescosOpciones : [];
    const campos_g = FORM_DICTIONARY.consentimiento.general;
    return (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            {/* Nombre Completo - OCULTO (pero se guarda) */}
            <Grid item xs={12} md={12} style={{ display: 'none' }} >
                <TextField
                    fullWidth
                    required
                    label={campos_g.nombre_completo_consent.label}
                    name={campos_g.nombre_completo_consent.name}
                    value={state.nombre_completo_consent.valor}
                    onChange={onChange}
                    error={onError(state.nombre_completo_consent.error)}
                    helperText={state.nombre_completo_consent.error}
                />
            </Grid>

            {/* Identificación - OCULTO (pero se guarda) */}
            <Grid item xs={12} md={12} style={{ display: 'none' }}>
                <TextField
                    fullWidth
                    required
                    label={campos_g.identificacion_consent.label}
                    name={campos_g.identificacion_consent.name}
                    value={state.identificacion_consent.valor}
                    onChange={onChange}
                    error={onError(state.identificacion_consent.error)}
                    helperText={state.identificacion_consent.error}
                />
            </Grid>

            {/* Celular - OCULTO (pero se guarda) */}
            <Grid item xs={12} md={12} style={{ display: 'none' }}>
                <TextField
                    fullWidth
                    required
                    type="number"
                    label={campos_g.celular_consent.label}
                    name={campos_g.celular_consent.name}
                    value={state.celular_consent.valor}
                    onChange={onChange}
                    error={onError(state.celular_consent.error)}
                    helperText={state.celular_consent.error}
                />
            </Grid>

            {/* Contacto de Emergencia 1 */}
            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    required
                    label={campos_g.contacto_emergencia_1.label}
                    name={campos_g.contacto_emergencia_1.name}
                    value={state.contacto_emergencia_1.valor}
                    onChange={onChange}
                    error={onError(state.contacto_emergencia_1.error)}
                    helperText={state.contacto_emergencia_1.error}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    required
                    type="number"
                    label={campos_g.celular_contacto_1.label}
                    name={campos_g.celular_contacto_1.name}
                    value={state.celular_contacto_1.valor}
                    onChange={onChange}
                    error={onError(state.celular_contacto_1.error)}
                    helperText={state.celular_contacto_1.error}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    select
                    fullWidth
                    required
                    label={campos_g.parentesco_contacto_1.label}
                    name={campos_g.parentesco_contacto_1.name}
                    value={state.parentesco_contacto_1.valor}
                    onChange={onChange}
                    error={onError(state.parentesco_contacto_1.error)}
                    helperText={state.parentesco_contacto_1.error}
                >
                    {parentescos.map((op) => (
                        <MenuItem key={op.value} value={op.value}>{op.label}</MenuItem>
                    ))}
                </TextField>
            </Grid>

            {/* Contacto de Emergencia 2 */}
            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    required
                    label={campos_g.contacto_emergencia_2.label}
                    name={campos_g.contacto_emergencia_2.name}
                    value={state.contacto_emergencia_2.valor}
                    onChange={onChange}
                    error={onError(state.contacto_emergencia_2.error)}
                    helperText={state.contacto_emergencia_2.error}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    required
                    type="number"
                    label={campos_g.celular_contacto_2.label}
                    name={campos_g.celular_contacto_2.name}
                    value={state.celular_contacto_2.valor}
                    onChange={onChange}
                    error={onError(state.celular_contacto_2.error)}
                    helperText={state.celular_contacto_2.error}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    select
                    fullWidth
                    required
                    label={campos_g.parentesco_contacto_2.label}
                    name={campos_g.parentesco_contacto_2.name}
                    value={state.parentesco_contacto_2.valor}
                    onChange={onChange}
                    error={onError(state.parentesco_contacto_2.error)}
                    helperText={state.parentesco_contacto_2.error}
                >
                    {parentescos.map((op) => (
                        <MenuItem key={op.value} value={op.value}>{op.label}</MenuItem>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    );
}

export function TextoConsentimiento({ tipo, fieldName, aceptado, onChange, state }) {
    const contenido = tipo === 'crisis' ? state.texto_consentimiento_crisis : state.texto_consentimiento_general;
    const colorTitulo = '#d32f2f';

    const handleCheckboxChange = (e) => {
        if (onChange && fieldName) {
            onChange({
                target: {
                    name: fieldName,
                    value: e.target.checked
                }
            });
        }
    };

    return (
        <Box style={{ marginBottom: '20px' }}>
            <Accordion defaultExpanded={false} style={{ border: '1px solid #e0e0e0' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ paddingTop: '12px', paddingBottom: '12px' }}>
                    <Box display="flex" alignItems="center" width="100%" justifyContent="space-between">
                        <Box display="flex" alignItems="center" gridGap={8}>
                            <NotificationsIcono style={{ color: colorTitulo }} fontSize="small" />
                            <Typography variant="subtitle2" style={{ fontWeight: '600', color: colorTitulo }}>
                                {contenido.titulo}
                            </Typography>
                        </Box>
                        <Typography variant="caption" style={{ color: '#666' }}>Ver más</Typography>
                    </Box>
                </AccordionSummary>
                <AccordionDetails style={{ display: 'block', padding: '16px', maxHeight: '350px', overflowY: 'auto', backgroundColor: '#fafafa' }}>
                                        {(() => {
                                            const texto = contenido.descripcion || "";
                                            let parrafos = texto.split(/\n\s*\n/);
                                            if (parrafos.length === 1) {
                                                parrafos = texto.split(/(?=\d+\. )/g);
                                            }
                                            return parrafos.map((parrafo, idx) => (
                                                <Typography
                                                    key={idx}
                                                    variant="body2"
                                                    style={{ textAlign: 'justify', whiteSpace: 'pre-line', marginBottom: '12px', color: '#555', fontSize: '0.875rem' }}
                                                >
                                                    {parrafo.trim()}
                                                </Typography>
                                            ));
                                        })()}
                    <Typography variant="caption" style={{ fontWeight: '500', fontStyle: 'italic', marginTop: '12px', color: '#666', display: 'block', marginBottom: '16px' }}>
                        {contenido.aceptacion}
                    </Typography>
                    {fieldName && (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={aceptado || false}
                                    onChange={handleCheckboxChange}
                                    name={fieldName}
                                    color="primary"
                                    size="small"
                                />
                            }
                            label={<Typography variant="caption" style={{ color: '#666' }}>Acepto los términos y condiciones</Typography>}
                        />
                    )}
                </AccordionDetails>
            </Accordion>
        </Box>
    );
}
